import React from 'react';

export const Logo = ({ className = "", size = "default" }) => {
  const sizes = {
    small: { icon: 20, text: "text-sm", subtext: "text-[8px]" },
    default: { icon: 28, text: "text-lg", subtext: "text-[9px]" },
    large: { icon: 40, text: "text-2xl", subtext: "text-xs" }
  };

  const { icon, text, subtext } = sizes[size] || sizes.default;

  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="logo">
      {/* Keystone Symbol - Inverted trapezoid shape */}
      <svg 
        width={icon} 
        height={icon} 
        viewBox="0 0 40 40" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className="flex-shrink-0"
      >
        {/* Keystone wedge shape */}
        <path 
          d="M4 8 L36 8 L30 32 L10 32 Z" 
          fill="#0F172A"
        />
      </svg>
      
      {/* Text */}
      <div className="flex flex-col leading-none">
        <span className={`font-semibold tracking-[0.12em] text-slate-900 ${text}`}>
          KEYSTONE
        </span>
        <span className={`font-medium tracking-[0.15em] text-slate-500 ${subtext} mt-0.5`}>
          STRATEGIC CONSULTANTS
        </span>
      </div>
    </div>
  );
};

export default Logo;
